import React, { useEffect } from "react";
import "./DashBoard.css";
import { BrowserRouter } from "react-router-dom";
import TopBar from "../topbar/TopBar";
import { useState } from "react";
import { useRef } from "react";
import user_logo from "../../assets/svg/user-logo.svg";
import van_logo from "../../assets/svg/van-logo.svg";
import couriers_logo from "../../assets/svg/couries-logo.svg";
import up_arrow from "../../assets/svg/up-arrow.svg";
import down_arrow from "../../assets/svg/down_arrow.svg";
import down_arrow_red from "../../assets/svg/down_arrow_red.svg";
import meeting_icon from "../../assets/svg/meeting_icon.svg";
import business_icon from "../../assets/svg/business_icon.svg";
import cleaning_icon from "../../assets/svg/cleaning_icon.svg";
import internship_icon from "../../assets/svg/internship_icon.svg";
import worker_icon from "../../assets/svg/worker_icon.svg";
import manual_entr_ic from "../../assets/svg/manual_entr_ics.svg";
import qr_icon from "../../assets/svg/qr_icon.svg";
import average_gate from "../../assets/svg/average_gate_icon.svg";
import scheduled_icon from "../../assets/svg/scheduled_icon.svg";
import vehicles_icon from "../../assets/svg/vehicles_icon.svg";
import overstayed_icon from "../../assets/svg/visitors_icon.svg";
import union_icon from "../../assets/svg/Union_icon.svg";
import booking_vector from "../../assets/svg/booking_vector.svg";
import line_border from "../../assets/svg/line-border.svg";
import total_attendance_user from "../../assets/svg/total-attendance-user.svg";
import total_attendance_vehicle from "../../assets/svg/total-attendance-vehicle.svg";
import total_attendance_courier from "../../assets/svg/total-attendance-courier.svg";
import locationRed from "../../assets/svg/locationRed.svg";
import historyClock from "../../assets/svg/historyClock.svg";
import blueGate from "../../assets/svg/blueGate.svg";
import greenDepartment from "../../assets/svg/greenDepartment.svg";
import blueOrg from "../../assets/svg/blueOrg.svg";
import greyPurpose from "../../assets/svg/greyPurpose.svg";
import meetingPerson from "../../assets/svg/yellowPerson.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import {
  getAverageApi,
  getCount,
  getCourierCount,
  getentryBased,
  getMonthlyCount,
  getoverstaycount,
  getpurpose,
  getregistCount,
  gettodayCount,
} from "./dashboard-api";
import {
  Overlay,
  Tooltip,
  Container,
  Row,
  Col,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import BarChart from "./barchart";
import ComplaintModal from "../modal-dialog/complaint-modal";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";

const DashBoard = ({ data = [] }) => {
  const navigate = useNavigate();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const progressRef = useRef(null);
  const maxValue = Math.max(...data.map((item) => item.value));
  const currentMonth = new Date().toLocaleString("default", { month: "short" });
  const currentMonthData = data.find((item) => item.label === currentMonth);

  const purposes = [
    { name: "Meeting", icon: meeting_icon, count: 665, percentage: 75 },
    { name: "Business", icon: business_icon, count: 443, percentage: 55 },
    { name: "Internship", icon: internship_icon, count: 542, percentage: 80 },
    { name: "Cleaning", icon: cleaning_icon, count: 197, percentage: 65 },
    { name: "Worker", icon: worker_icon, count: 1585, percentage: 85 },
  ];

  const [preRegisterWidth, setPreRegisterWidth] = useState(50);
  const myRef = useRef(null);
  const [directRegisterWidth, setDirectRegisterWidth] = useState(85);
  const [hoveredBar, setHoveredBar] = useState(null);
  const [hoveredValue, setHoveredValue] = useState(
    currentMonthData ? currentMonthData.value : null
  );
  const [activeService, setActiveService] = useState("visitor");
  const [isOpen, setIsOpen] = useState(false);
  const [gateDetials, setIsGateDetials] = useState({});
  const [orgCreateDate, setOrgCreateDate] = useState("");
  const [averageDetails, setAverageDetails] = useState({});
  const [visitorDetails, setvisitorDetails] = useState({});
  const [vehicleDetails, setvehicleDetails] = useState({});
  const [courierDetails, setcourierDetails] = useState({});
  const [purposeslist, setpurposeslist] = useState([]);
  const [totalpercentPurpose, settotalpercentPurpose] = useState(0);
  const [purposesTotal, setpurposesTotal] = useState(0);
  const [qrPerct, setqrPerct] = useState(0);
  const [manualPerct, setmanualPerct] = useState(0);
  const [entryCounts, setEntryCounts] = useState({});
  const [overCount, setOverCount] = useState({});
  const [courierCount, setcourierCount] = useState({});
  const [registCount, setregistCount] = useState({});
  const [todayAttCount, settodayAttCount] = useState({});
  const [todayAttVistCount, settodayAttVistCount] = useState({});
  const [todayAttVehCount, settodayAttVehCount] = useState({});
  const [todayAttCourCount, settodayAttCourCount] = useState({});
  const [todayAttvalueCount, settodayAttvalueCount] = useState(0);
  const [toAttVisitPercent, settoAttVisitPercent] = useState(0);
  const [toAttVehPercent, settoAttVehPercent] = useState(0);
  const [toAttCourPercent, settoAttCourPercent] = useState(0);
  const [monthlyDiff, setmonthlyDiff] = useState(0);
  const [monthlyPercent, setmonthlyPercent] = useState(0);
  const [monthlyIsLow, setmonthlyIsLow] = useState(false);
  const [monthlyList, setMonthlyList] = useState([]);
  const [visitormonthlyList, setvisitorMonthlyList] = useState([]);
  const [vehiclemonthlyList, setvehicleMonthlyList] = useState([]);
  const [couriermonthlyList, setvcourierMonthlyList] = useState([]);
  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("Feb");
  const [selectedYear, setSelectedYear] = useState("2024");
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(23);
  const [selectedAttendanceMonth, setSelectedAttendanceMonth] = useState("Feb");
  const [selectedAttendanceYear, setSelectedAttendanceYear] = useState("2024");
  const [activeDashboard, setActiveDashboard] = useState("Dashboard");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const years = Array.from({ length: 20 }, (_, i) => 2030 - i);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const stats = [
    { label: "APPROVED", value: 560 },
    { label: "CHECK LIST FAILED", value: 560 },
    { label: "GATE IN", value: 560 },
    { label: "SCHEDULED", value: 560 },
    { label: "REJECTED", value: 560 },
    { label: "COMPLETED", value: 560 },
  ];

  // number of columns (used to place ticks)
  const cols = stats.length;

  const locationSets = [
    [
      { city: "Chennai", value: 15, max: 100 },
      { city: "Erode", value: 75, max: 100 },
      { city: "Madurai", value: 35, max: 100 },
      { city: "Tirupur", value: 55, max: 100 },
      { city: "Delhi", value: 100, max: 100 },
    ],

    [
      { city: "Mumbai", value: 40, max: 100 },
      { city: "Pune", value: 80, max: 100 },
      { city: "Nagpur", value: 25, max: 100 },
      { city: "Delhi", value: 100, max: 100 },
    ],
    [
      { city: "Chennai", value: 15, max: 100 },
      { city: "Erode", value: 75, max: 100 },
      { city: "Madurai", value: 35, max: 100 },
      { city: "Tirupur", value: 55, max: 100 },
      { city: "Delhi", value: 100, max: 100 },
    ],
  ];
  const gateSets = [
    [
      { gate: "Gate 1", value: 15, max: 100 },
      { gate: "Gate 2", value: 75, max: 100 },
      { gate: "Gate 3", value: 35, max: 100 },
      { gate: "Gate 4", value: 55, max: 100 },
      { gate: "Gate 5", value: 100, max: 100 },
    ],

    [
      { gate: "Gate 1", value: 40, max: 100 },
      { gate: "Gate 2", value: 80, max: 100 },
      { gate: "Gate 3", value: 25, max: 100 },
      { gate: "Gate 4", value: 100, max: 100 },
    ],
    [
      { gate: "Gate 1", value: 15, max: 100 },
      { gate: "Gate 2", value: 75, max: 100 },
      { gate: "Gate 3", value: 35, max: 100 },
      { gate: "Gate 4", value: 55, max: 100 },
      { gate: "Gate 5", value: 100, max: 100 },
    ],
    [
      { gate: "Gate 1", value: 40, max: 100 },
      { gate: "Gate 2", value: 80, max: 100 },
      { gate: "Gate 3", value: 25, max: 100 },
      { gate: "Gate 4", value: 100, max: 100 },
    ],
  ];

  // department

  const departmentSets = [
    [
      { dept: "Production", value: 15, max: 100 },
      { dept: "Quality Checking", value: 75, max: 100 },
      { dept: "Manufacturing", value: 35, max: 100 },
      { dept: "Support", value: 55, max: 100 },
      { dept: "Consulting", value: 100, max: 100 },
    ],
    [
      { dept: "Manufacturing", value: 40, max: 100 },
      { dept: "Consulting", value: 80, max: 100 },
      { dept: "Production", value: 25, max: 100 },
      { dept: "Quality Control", value: 100, max: 100 },
    ],
    [
      { dept: "Production", value: 15, max: 100 },
      { dept: "Quality Checking", value: 75, max: 100 },
      { dept: "Manufacturing", value: 35, max: 100 },
      { dept: "Support", value: 55, max: 100 },
      { dept: "Consulting", value: 100, max: 100 },
    ],
    [
      { dept: "Manufacturing", value: 40, max: 100 },
      { dept: "Consulting", value: 80, max: 100 },
      { dept: "Production", value: 25, max: 100 },
      { dept: "Quality Control", value: 100, max: 100 },
    ],
    [
      { dept: "Production", value: 15, max: 100 },
      { dept: "Quality Checking", value: 75, max: 100 },
      { dept: "Manufacturing", value: 35, max: 100 },
      { dept: "Support", value: 55, max: 100 },
      { dept: "Consulting", value: 100, max: 100 },
    ],
  ];

  // organization

  const organizationSets = [
    [
      { organization: "Chennai", value: 15, max: 100 },
      { organization: "Erode", value: 75, max: 100 },
      { organization: "Madurai", value: 35, max: 100 },
      { organization: "Tirupur", value: 55, max: 100 },
      { organization: "Delhi", value: 100, max: 100 },
    ],

    [
      { organization: "Mumbai", value: 40, max: 100 },
      { organization: "Pune", value: 80, max: 100 },
      { organization: "Nagpur", value: 25, max: 100 },
      { organization: "Delhi", value: 100, max: 100 },
    ],
  ];

  // purpose
  const purposeSets = [
    [
      { purpose: "Business meeting", value: 15, max: 100 },
      { purpose: "Discussion", value: 75, max: 100 },
      { purpose: "Casual meeting", value: 35, max: 100 },
      { purpose: "Checking", value: 55, max: 100 },
      { purpose: "Maintenance", value: 100, max: 100 },
    ],
    [
      { purpose: "Mumbai", value: 40, max: 100 },
      { purpose: "Pune", value: 80, max: 100 },
      { purpose: "Nagpur", value: 25, max: 100 },
      { purpose: "Delhi", value: 100, max: 100 },
    ],
  ];

  // meetin person
  const meetingPersonSets = [
    [
      { person: "Business meeting", value: 15, max: 100 },
      { person: "Discussion", value: 75, max: 100 },
      { person: "Casual meeting", value: 35, max: 100 },
      { person: "Checking", value: 55, max: 100 },
      { person: "Maintenance", value: 100, max: 100 },
    ],
    [
      { person: "Mumbai", value: 40, max: 100 },
      { person: "Pune", value: 80, max: 100 },
      { person: "Nagpur", value: 25, max: 100 },
      { person: "Delhi", value: 100, max: 100 },
    ],
  ];

  useEffect(() => {
    getAverageDetails();
    getCounts();
    getpurposes();
    getEntries();
    getOverStayCount();
    getCourierCounts();
    getregisCounts();
    getmonthlycounts(activeService);
    gettodayCounts();
  }, []);
  const handleSelect = (month, year) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    setIsOpen(false);
  };
  const handleAttendanceSelect = (day, month, year) => {
    setSelectedDay(day);
    setSelectedAttendanceMonth(month);
    setSelectedAttendanceYear(year);
    setIsAttendanceOpen(false);
  };

  const getAverageDetails = async () => {
    try {
      const response = await getAverageApi();
      if (response.status === true) {
        setAverageDetails(response.data ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getCounts = async () => {
    try {
      const response = await getCount();
      if (response.status === true) {
        setIsGateDetials(response.count ?? {});
        setOrgCreateDate(response.count.from_date ?? "");
        setvisitorDetails(response.count.visitors ?? {});
        setvehicleDetails(response.count.vehicles ?? {});
        setcourierDetails(response.count.couriers ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getpurposes = async () => {
    try {
      const response = await getpurpose();
      if (response.status === true) {
        setpurposesTotal(response.total ?? 0);
        setpurposeslist(response.data ?? []);

        settotalpercentPurpose(response.percent ?? 0);

        console.log(purposeslist);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getEntries = async () => {
    try {
      const response = await getentryBased();
      if (response.status === true) {
        setEntryCounts(response.count ?? []);

        setqrPerct(response.count.qr_percent ?? 0);
        setmanualPerct(response.count.manual_percent ?? 0);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getOverStayCount = async () => {
    try {
      const response = await getoverstaycount();
      if (response.status === true) {
        setOverCount(response.count ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getCourierCounts = async () => {
    try {
      const response = await getCourierCount();
      if (response.status === true) {
        setcourierCount(response.count ?? {});
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getregisCounts = async () => {
    try {
      const response = await getregistCount();
      if (response.status === true) {
        setregistCount(response.count ?? {});
        const directPercentage = parseFloat(
          ((response.count.direct / response.count.total) * 100).toFixed(2)
        );
        const schedulePercentage = parseFloat(
          ((response.count.schedule / response.count.total) * 100).toFixed(2)
        );

        setDirectRegisterWidth(directPercentage);
        setPreRegisterWidth(schedulePercentage);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getmonthlycounts = async (type) => {
    try {
      const response = await getMonthlyCount();
      if (response.status === true) {
        setMonthlyList(response.MonthlyAttandence ?? {});
        if (type === "visitor") {
          setmonthlyDiff(response.MonthlyAttandence.visitor.diff ?? 0);
          setmonthlyPercent(response.MonthlyAttandence.visitor.percent ?? 0);
          setmonthlyIsLow(response.MonthlyAttandence.visitor.is_low ?? false);
        } else if (type === "vehicle") {
          setmonthlyDiff(response.MonthlyAttandence.vehicle.diff ?? 0);
          setmonthlyPercent(response.MonthlyAttandence.vehicle.percent ?? 0);
          setmonthlyIsLow(response.MonthlyAttandence.vehicle.is_low ?? false);
        } else if (type === "courier") {
          setmonthlyDiff(response.MonthlyAttandence.courier.diff ?? 0);
          setmonthlyPercent(response.MonthlyAttandence.courier.percent ?? 0);
          setmonthlyIsLow(response.MonthlyAttandence.courier.is_low ?? false);
        }
        setvisitorMonthlyList(response.MonthlyAttandence.visitor.count ?? []);
        setvehicleMonthlyList(response.MonthlyAttandence.vehicle.count ?? []);
        setvcourierMonthlyList(response.MonthlyAttandence.courier.count ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const gettodayCounts = async () => {
    try {
      const response = await gettodayCount();
      if (response.status === true) {
        settodayAttCount(response.TodayAttandence ?? {});
        settodayAttVistCount(response.TodayAttandence.visitors ?? 0);
        settodayAttVehCount(response.TodayAttandence.vehicle ?? 0);
        settodayAttCourCount(response.TodayAttandence.courier ?? 0);
        const Totalvisitor = response.TodayAttandence.visitors.Totalvisitor;
        const Totalvehicle = response.TodayAttandence.vehicle.Totalvehicle;
        const Totalcourier = response.TodayAttandence.courier.Totalcourier;

        // Calculate total count
        const totalCount = Totalvisitor + Totalvehicle + Totalcourier;

        // Calculate percentages
        const vehiclePercentage =
          totalCount > 0 ? ((Totalvehicle / totalCount) * 100).toFixed(2) : 0;
        const courierPercentage =
          totalCount > 0 ? ((Totalcourier / totalCount) * 100).toFixed(2) : 0;
        const visitotPercentage =
          totalCount > 0 ? ((Totalcourier / totalCount) * 100).toFixed(2) : 0;
        settodayAttvalueCount(totalCount);
        settoAttVisitPercent(visitotPercentage);
        settoAttVehPercent(vehiclePercentage);
        settoAttCourPercent(courierPercentage);
        console.log("Vehicle Percentage:", vehiclePercentage + "%");
        console.log("Courier Percentage:", courierPercentage + "%");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  // autoplay swipers
  // location
  const [activeLocation, setActiveLocation] = useState(0);
  const paginationCountLocation = locationSets.length;
  const autoplayDelay = 1500;
  const swiperRefLocation = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveLocation((prev) => {
        const next = (prev + 1) % paginationCountLocation;
        // Move swiper slide
        if (swiperRefLocation.current) {
          swiperRefLocation.current.slideToLoop(next);
        }
        return next;
      });
    }, autoplayDelay);
    return () => clearInterval(interval);
  }, []);
  // gate
  const [activeGate, setActiveGate] = useState(0);
  const paginationCountGate = gateSets.length;
  const swiperRefGate = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveGate((prev) => {
        const next = (prev + 1) % paginationCountGate;

        // Move swiper slide
        if (swiperRefGate.current) {
          swiperRefGate.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, []);

  // department
  const [activeDepartment, setActiveDepartment] = useState(0);
  const paginationCountDepartment = departmentSets.length;
  const swiperRefDepartment = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDepartment((prev) => {
        const next = (prev + 1) % paginationCountDepartment;

        // Move swiper slide
        if (swiperRefDepartment.current) {
          swiperRefDepartment.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, []);

  // organization
  const [activeOrganization, setActiveOrganization] = useState(0);
  const paginationCountOrganization = organizationSets.length;
  const swiperRefOrganization = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveOrganization((prev) => {
        const next = (prev + 1) % paginationCountOrganization;

        // Move swiper slide
        if (swiperRefOrganization.current) {
          swiperRefOrganization.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, []);

  // purpose
  const [activePurpose, setActivePurpose] = useState(0);
  const paginationCountPurpose = purposeSets.length;
  const swiperRefPurpose = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActivePurpose((prev) => {
        const next = (prev + 1) % paginationCountPurpose;

        // Move swiper slide
        if (swiperRefPurpose.current) {
          swiperRefPurpose.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, []);

  // meeting person
  const [activeMeetingPerson, setActiveMeetingPerson] = useState(0);
  const paginationCountMeetingPerson = meetingPersonSets.length;
  const swiperRefMeetingPerson = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveMeetingPerson((prev) => {
        const next = (prev + 1) % paginationCountMeetingPerson;

        // Move swiper slide
        if (swiperRefMeetingPerson.current) {
          swiperRefMeetingPerson.current.slideToLoop(next);
        }

        return next;
      });
    }, autoplayDelay);

    return () => clearInterval(interval);
  }, []);
  return (
    <Container
      fluid
      className="main-container"
      style={{
        width: "100vw",
        display: "flex",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      <div style={{ width: "100vw" }}>
        <div>
          <TopBar currentName="dashboard" />
        </div>
        <div
          className="mx-1"
          style={{ width: "100vw", display: "flex", flexDirection: "column" }}
        >
          <div style={{ width: "100vw", padding: "12px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                className="mb-2"
                style={{
                  borderRadius: "100px",
                  padding: "6px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <div
                  onClick={() => {
                    setActiveDashboard("Dashboard");
                    navigate("/dashboard");
                  }}
                  style={{
                    borderRadius: "100px",
                    padding: "8px 20px",
                    gap: "8px",
                    backgroundColor:
                      activeDashboard === "Dashboard" ? "#172B4D" : "#FFFFFF",
                    fontSize: "12px",
                    color:
                      activeDashboard === "Dashboard" ? "#FFFFFF" : "#172B4D",
                    fontWeight: activeDashboard === "Dashboard" ? "600" : "500",
                    cursor: "pointer",
                  }}
                >
                  Dashboard
                </div>
                <div
                  onClick={() => {
                    setActiveDashboard("Visitor Dashboard");
                    navigate("/visitor-dashboard");
                  }}
                  style={{
                    borderRadius: "100px",
                    padding: "8px 20px",
                    gap: "8px",
                    backgroundColor:
                      activeDashboard === "Visitor Dashboard"
                        ? "#172B4D"
                        : "#FFFFFF",
                    fontSize: "13.5px",
                    color:
                      activeDashboard === "Visitor Dashboard"
                        ? "#FFFFFF"
                        : "#172B4D",
                    fontWeight:
                      activeDashboard === "Visitor Dashboard" ? "600" : "500",
                    cursor: "pointer",
                  }}
                >
                  Visitor Dashboard
                </div>
              </div>
              <div className="dashboard">
                <div className="dashboard-head">
                  <div className="dashboard-content">
                    From the date of{" "}
                    <span>
                      {orgCreateDate} to{" "}
                      {new Date().toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <>
              <Row className="section-part" style={{ width: "100vw" }}>
                <Col sm={12} md={6} lg={8} xs={8}>
                  {/* Visitors Card */}
                  <Row>
                    <Col sm={12} md={4}>
                      <div className="content1">
                        <div className="content1-head">
                          <img src={user_logo} alt="Visitors" />
                          <div className="text-container">
                            <span className="number">
                              {visitorDetails.total ?? 0}
                            </span>
                            <span className="visitors">Visitors</span>
                          </div>
                        </div>
                        <div className="calculation-container">
                          <div className="calculation-row">
                            <span>From last month</span>
                            <span>Average Duration</span>
                          </div>
                          <div className="calculation-values">
                            <div className="calculation-left">
                              <span
                                className={
                                  visitorDetails.differenceValue === "lesser"
                                    ? "negative"
                                    : "positive"
                                }
                              >
                                + {visitorDetails.Percentage} %
                              </span>
                              <span className="highlight-box">
                                <img
                                  src={
                                    visitorDetails.differenceValue === "lesser"
                                      ? down_arrow_red
                                      : up_arrow
                                  }
                                  alt="Increase1"
                                  className="icon1"
                                />{" "}
                                {visitorDetails.Difference}
                              </span>
                            </div>
                            <div className="calculation-right">
                              <span>{visitorDetails.InTimeaverage} hrs</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Vehicles Card */}
                    <Col sm={12} md={4}>
                      <div className="content1">
                        <div className="content1-head">
                          <img src={van_logo} alt="Vehicles" />
                          <div className="text-container">
                            <span className="number">
                              {vehicleDetails.total ?? 0}
                            </span>
                            <span className="visitors">Vehicles</span>
                          </div>
                        </div>
                        <div className="calculation-container">
                          <div className="calculation-row">
                            <span>From last month</span>
                            <span>Average Duration</span>
                          </div>
                          <div className="calculation-values">
                            <div className="calculation-left">
                              <span
                                className={
                                  vehicleDetails.differenceValue === "lesser"
                                    ? "negative"
                                    : "positive"
                                }
                              >
                                + {vehicleDetails.Percentage} %
                              </span>
                              <span className="highlight-box">
                                <img
                                  src={
                                    vehicleDetails.differenceValue === "lesser"
                                      ? down_arrow_red
                                      : up_arrow
                                  }
                                  alt="Increase1"
                                  className="icon1"
                                />{" "}
                                {vehicleDetails.Difference}
                              </span>
                            </div>
                            <div className="calculation-right">
                              <span>{vehicleDetails.InTimeaverage} hrs</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* Couriers Card */}
                    <Col sm={12} md={4}>
                      <div className="content1">
                        <div className="content1-head">
                          <img src={couriers_logo} alt="Couriers" />
                          <div className="text-container">
                            <span className="number">
                              {courierDetails.total ?? 0}
                            </span>
                            <span className="visitors">Couriers</span>
                          </div>
                        </div>
                        <div className="calculation-container">
                          <div className="calculation-row">
                            <span>From last month</span>
                            <span>Average Duration</span>
                          </div>
                          <div className="calculation-values">
                            <div className="calculation-left">
                              <span
                                className={
                                  courierDetails.differenceValue === "lesser"
                                    ? "negative"
                                    : "positive"
                                }
                              >
                                + {courierDetails.Percentage} %
                              </span>
                              <span className="highlight-box">
                                <img
                                  src={
                                    courierDetails.differenceValue === "lesser"
                                      ? down_arrow_red
                                      : up_arrow
                                  }
                                  alt="Increase1"
                                  className="icon1"
                                />{" "}
                                {courierDetails.Difference}
                              </span>
                            </div>
                            <div className="calculation-right">
                              <span>{courierDetails.InTimeaverage} hrs</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col sm={12} md={6} lg={4} xs={4}>
                  <div className="gate-activities">
                    <div className="gate-content1">
                      <h3>Average Gate in Activities</h3>
                      <div className="gate-table">
                        <div className="gate-row">
                          <span className="gate-cell">
                            {averageDetails.visitors ?? 0}
                          </span>
                          <span className="gate-cell">
                            {averageDetails.vehicle ?? 0}
                          </span>
                          <span className="gate-cell">
                            {averageDetails.courier ?? 0}
                          </span>
                        </div>
                        <div className="gate-row">
                          <span className="gate-text">Visitor entries</span>
                          <span className="gate-text">Vehicles entries</span>
                          <span className="gate-text">Courier entries</span>
                        </div>
                      </div>
                      <p className="gate-records">
                        <img src={average_gate} alt="" />
                        From{" "}
                        <span className="highlighted">{orgCreateDate}</span> to
                        present records
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12} md={3}>
                  <div className="purpose-based-container">
                    <h3>Purpose based visitor</h3>
                    <div className="purpose-based">
                      <div className="purpose-header">
                        <span className="number">
                          {totalpercentPurpose}
                          <span className="percentage"> %</span>
                        </span>
                        <div className="text" style={{ width: "100%" }}>
                          <span>Coverage of these top 5 purposes: %</span>
                        </div>
                      </div>

                      <div
                        className="purpose-content"
                        style={{ width: "100%" }}
                      >
                        {purposeslist.map((purpose, index) => (
                          <div key={index}>
                            <div className="purpose-name">{purpose.name} </div>
                            <div className="purpose-item">
                              {/* <img src={purpose.icon} alt={purpose.name} /> */}

                              <progress
                                className="custom-progress"
                                value={purpose.count}
                                max={purposesTotal}
                              />
                              {/* <div className="progress-bar">
                            <div className="progress" style={{ width: `${purpose.percentage}%` }}></div>
                        </div>  */}
                              <span className="count">{purpose.count}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={9}>
                  <Row>
                    <Col sm={12} md={6}>
                      <div>
                        <div className="entry-container">
                          <div className="entry-box">
                            <h3>QR Entry</h3>
                            <p>Ensures secured gate-in process</p>
                            <div className="qr-entry-bar">
                              <div className="circle-progress-bar">
                                <div className="circle-container">
                                  <CircularProgressbar
                                    value={entryCounts.qr_code}
                                    maxValue={entryCounts.total}
                                    strokeWidth={5}
                                    circleRatio={0.8}
                                    styles={buildStyles({
                                      pathColor: "#5DCB8C",
                                      trailColor: "#e0e0e0",
                                      textSize: "16px",
                                      rotation: "0.600",
                                    })}
                                  />
                                  <div className="progress-text">
                                    <p>Total</p>
                                    <span>{entryCounts.qr_code} </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <span className="entries">
                              <img src={qr_icon} alt="QR Icon" />
                              QR entry accounts for {qrPerct} % of the total
                              entries
                            </span>
                          </div>

                          <div className="manual-box">
                            <h3>Manual Entry</h3>
                            <p>Ensures secured gate-in process</p>
                            <div className="manual-bar">
                              <div className="circle-progress-bar">
                                <div className="circle-container">
                                  <CircularProgressbar
                                    value={entryCounts.manual}
                                    maxValue={entryCounts.total}
                                    strokeWidth={5}
                                    circleRatio={0.8}
                                    styles={buildStyles({
                                      pathColor: "#5DCB8C",
                                      trailColor: "#e0e0e0",
                                      textSize: "16px",
                                      rotation: "0.600",
                                    })}
                                  />
                                  <div className="progress-text">
                                    <p>Total</p>
                                    <span>{entryCounts.manual} </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <span className="entries">
                              <img src={manual_entr_ic} alt="QR Icon" />
                              Manual entry accounts for {manualPerct} % of the
                              total entries
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm={12} md={6}>
                      <div className="gate-content2">
                        <div className="gate-cards" style={{ flex: 3 }}>
                          <div className="gate-card" style={{ flex: 1 }}>
                            <img
                              className="gate-img"
                              src={scheduled_icon}
                              alt=""
                            />
                            <span className="gate-text2">
                              Upcoming <br /> Scheduled Visits
                            </span>
                            <span className="gate-number">
                              {overCount.schedule_count}
                            </span>
                          </div>

                          <div className="gate-card" style={{ flex: 1 }}>
                            <img
                              className="gate-img"
                              src={overstayed_icon}
                              alt=""
                            />
                            <span className="gate-text2">
                              Overstayed <br /> Visitors
                            </span>
                            <span className="gate-number">
                              {overCount.visitor_count}
                            </span>
                          </div>

                          <div className="gate-card" style={{ flex: 1 }}>
                            <img
                              className="gate-img"
                              src={vehicles_icon}
                              alt=""
                            />
                            <span className="gate-text2">
                              Overstayed <br /> Vehicles
                            </span>
                            <span className="gate-number">
                              {overCount.vehicle_count}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        className="gate-content3 mt-3"
                        style={{
                          alignItems: "center",
                          padding: "12px",
                          /*  width: "105%", */
                        }}
                      >
                        <h5>Courier Status</h5>
                        <div
                          className="courier-table"
                          style={{ width: "445px" }}
                        >
                          <div className="courier-row">
                            {/* Background union shape */}
                            <img
                              src={union_icon}
                              alt=""
                              style={{ width: "473px" }}
                              className="union-image"
                            />

                            {/* Circles above the image */}
                            <div className="courier-cell">
                              <span className="courier-label">Received</span>
                              <span className="courier-text">
                                {courierCount.received ?? 0}
                              </span>
                            </div>
                            <div className="courier-cell">
                              <span className="courier-label">Total</span>
                              <span className="courier-text">
                                {courierCount.total ?? 0}
                              </span>
                            </div>
                            <div className="courier-cell">
                              <span className="courier-label">Unreceived</span>
                              <span className="courier-text">
                                {courierCount.not_received ?? 0}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12} md={3}>
                  <div className="all-booking hide-scroll">
                    <div className="registerations">
                      <div className="registerations-count">
                        <p>Total registrations count</p>
                        <div className="right-content">
                          <span className="number">
                            {registCount.total ?? 0}
                          </span>
                          <span className="text">From {orgCreateDate}</span>
                        </div>
                      </div>
                      <div className="register">
                        <div className="pre-register">
                          <div className="pre-register-content">
                            {/* <span className="reg-head">Pre - Register</span> */}
                            {/* <span className="number">{registCount.schedule ?? 0}</span> */}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span className="reg-head">Pre - Register</span>
                              <span className="number">
                                {registCount.schedule ?? 0}
                              </span>
                            </div>

                            <div className="pre-register-bar">
                              <span className="text">
                                Count of this entries
                              </span>
                              {/* Progress Bar */}
                              <div
                                className="preregister-bar-container"
                                onMouseEnter={() =>
                                  setHoveredBar("preRegister")
                                }
                                onMouseLeave={() => setHoveredBar(null)}
                              >
                                <div
                                  className="register-bar"
                                  style={{ width: `${preRegisterWidth}%` }}
                                ></div>

                                {/* Show percentage only when hovering */}
                                {hoveredBar === "preRegister" && (
                                  <div
                                    className="hover-number"
                                    style={{
                                      left: `${Math.min(
                                        preRegisterWidth,
                                        100
                                      )}%`,
                                      transform:
                                        preRegisterWidth > 100
                                          ? "translateX(-100%)"
                                          : "translateX(0)",
                                    }}
                                  >
                                    {preRegisterWidth}%
                                  </div>
                                )}
                              </div>

                              <div className="progress-labels">
                                <span>0%</span>
                                <span>100%</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="direct-register">
                          <div className="direct-register-content">
                            {/* <span className="reg-head">Direct Registration</span>
                             */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span className="reg-head">
                                Direct Registration
                              </span>
                              <span className="number">
                                {registCount.direct ?? 0}
                              </span>
                            </div>
                            <div className="direct-register-bar">
                              {/* <span className="number">{registCount.direct ?? 0}</span> */}
                              <span className="text">
                                Count of this entries
                              </span>

                              {/* Progress Bar */}
                              <div
                                className="preregister-bar-container"
                                onMouseEnter={() =>
                                  setHoveredBar("directRegister")
                                }
                                onMouseLeave={() => setHoveredBar(null)}
                              >
                                <div
                                  className="register-bar"
                                  style={{ width: `${directRegisterWidth}%` }}
                                ></div>

                                {/* Show percentage only when hovering */}
                                {hoveredBar === "directRegister" && (
                                  <div
                                    className="hover-number"
                                    style={{
                                      left: `${Math.min(
                                        directRegisterWidth,
                                        100
                                      )}%`,
                                      transform:
                                        directRegisterWidth > 100
                                          ? "translateX(-100%)"
                                          : "translateX(0)",
                                    }}
                                  >
                                    {directRegisterWidth}%
                                  </div>
                                )}
                              </div>

                              <div className="progress-labels">
                                <span>0%</span>
                                <span>100%</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={9}>
                  <Row>
                    <Col sm={12} md={6}>
                      <div className="booking">
                        <div className="booking-head">
                          <span className="booking-head1">
                            Monthly Bookings
                          </span>
                          {/* <span className="booking-head2" onClick={() => setIsOpen(!isOpen)}>
                {selectedMonth}, {selectedYear} <img src={booking_vector} alt="" />
              </span> */}

                          {isOpen && (
                            <div className="downarrow">
                              <div className="month-list">
                                {months.map((month) => (
                                  <div
                                    key={month}
                                    className={`month-item ${
                                      month === selectedMonth ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      handleSelect(month, selectedYear)
                                    }
                                  >
                                    {month}
                                  </div>
                                ))}
                              </div>
                              <div className="year-list">
                                {years.map((year) => (
                                  <div
                                    key={year}
                                    className={`year-item ${
                                      year === selectedYear ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      handleSelect(selectedMonth, year)
                                    }
                                  >
                                    {year}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="tri-services">
                          <span
                            className={`service-item ${
                              activeService === "visitor" ? "active" : ""
                            }`}
                            onClick={() => {
                              setActiveService("visitor");
                              getmonthlycounts("visitor");
                            }}
                          >
                            Visitor
                          </span>
                          <span
                            className={`service-item ${
                              activeService === "vehicle" ? "active" : ""
                            }`}
                            onClick={() => {
                              setActiveService("vehicle");
                              getmonthlycounts("vehicle");
                            }}
                          >
                            Vehicle
                          </span>
                          <span
                            className={`service-item ${
                              activeService === "courier" ? "active" : ""
                            }`}
                            onClick={() => {
                              setActiveService("courier");
                              getmonthlycounts("courier");
                            }}
                          >
                            Courier
                          </span>
                        </div>
                        <div className="book-graph">
                          <div className="book-graph-content1">
                            <h3>{monthlyPercent} %</h3>
                            <p className="book-graph-content2">
                              Increased from last month
                            </p>
                            <div className="book-graph-content3">
                              <p className="increased_count">
                                <img src={line_border} alt="increase icon" />
                                {monthlyIsLow === true
                                  ? "Decreased"
                                  : "Increased"}{" "}
                                count
                                <span className="book-border">
                                  <img
                                    src={
                                      monthlyIsLow === true
                                        ? down_arrow_red
                                        : up_arrow
                                    }
                                    alt="increase icon"
                                  />
                                  {monthlyDiff}
                                </span>
                              </p>
                            </div>
                            <BarChart
                              dataList={
                                activeService === "visitor"
                                  ? visitormonthlyList
                                  : activeService === "vehicle"
                                  ? vehiclemonthlyList
                                  : couriermonthlyList
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col sm={12} md={6}>
                      <div className="total-attendance">
                        <div className="total-attendance-head">
                          <span className="total-attendance-head1">
                            Today Attendance
                          </span>
                          {/* <span className="booking-head2" onClick={() => setIsOpen(!isOpen)}>
                        {selectedMonth}, {selectedYear} <img src={booking_vector} alt="" />
                      </span> */}
                          {/* <div >
                        <DatePicker
                          selected={selectedDate}
                          onChange={(date) => setSelectedDate(date)} 
                          // popperPlacement="top-start" // or "top-end", "auto", etc.
                          // popperModifiers={[
                          //   {
                          //     name: 'preventOverflow',
                          //     options: {
                          //       boundary: 'viewport',
                          //     },
                          //   },
                          // ]}
                          customInput={
                            <div
                              className="booking-head2"
                            >
                              {selectedDate.toDateString()}<img style={{ paddingBottom: '6px' }} src={booking_vector} alt="" />
                            </div>
                          }
                        />
                      </div> */}
                          {isAttendanceOpen && (
                            <div className="droparrow">
                              <div className="day-list">
                                {days.map((day) => (
                                  <div
                                    key={day}
                                    className={`day-item ${
                                      day === selectedDay ? "active" : ""
                                    }`}
                                    onClick={() =>
                                      handleAttendanceSelect(
                                        day,
                                        selectedAttendanceMonth,
                                        selectedAttendanceYear
                                      )
                                    }
                                  >
                                    {day}
                                  </div>
                                ))}
                              </div>
                              <div className="month-list">
                                {months.map((month) => (
                                  <div
                                    key={month}
                                    className={`month-item ${
                                      month === selectedAttendanceMonth
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      handleAttendanceSelect(
                                        selectedDay,
                                        month,
                                        selectedAttendanceYear
                                      )
                                    }
                                  >
                                    {month}
                                  </div>
                                ))}
                              </div>
                              <div className="year-list">
                                {years.map((year) => (
                                  <div
                                    key={year}
                                    className={`year-item ${
                                      year === selectedAttendanceYear
                                        ? "active"
                                        : ""
                                    }`}
                                    onClick={() =>
                                      handleAttendanceSelect(
                                        selectedDay,
                                        selectedAttendanceMonth,
                                        year
                                      )
                                    }
                                  >
                                    {year}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="total-attendance-content1">
                          <h3> {todayAttvalueCount}</h3>
                          <p className="total-attendance-content2">
                            Overall today entries of your orgnization
                          </p>
                          <div className="total-attendance-content3">
                            <p className="increased_count">
                              <span
                                className="total-attendance-highlighted"
                                style={{
                                  color:
                                    todayAttCount.is_low === true
                                      ? "#FF4444"
                                      : "#2C8C53",
                                }}
                              >
                                {todayAttCount.is_low === true ? "-" : "+"}
                                {todayAttCount.percent}%{" "}
                              </span>
                              <span> From yesterday </span>
                              <span className="book-border">
                                <img
                                  src={
                                    todayAttCount.is_low === true
                                      ? down_arrow_red
                                      : up_arrow
                                  }
                                  alt="increase icon"
                                />
                                {todayAttCount.diff}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="total-attendance-bar">
                          <div className="attendance-bar-container">
                            <div
                              className="attendance-bar-visitors"
                              style={{ width: `${toAttVisitPercent}%` }}
                            ></div>
                            <div
                              className="attendance-bar-vehicles"
                              style={{ width: `${toAttVehPercent}%` }}
                            ></div>

                            <div
                              className="attendance-bar-couriers"
                              style={{ width: `${toAttCourPercent}%` }}
                            ></div>
                          </div>
                        </div>
                        <div className="three-content">
                          <div className="total-attendance-cards">
                            <div className="total-attendance-card">
                              <img
                                className="total-attendance-img"
                                src={total_attendance_user}
                                alt=""
                              />
                              <span className="total-attendance-text2">
                                Visitor
                              </span>
                              <span className="total-attendance-number">
                                {todayAttVistCount.Totalvisitor}
                              </span>
                            </div>

                            <div className="total-attendance-card">
                              <img
                                className="total-attendance-img"
                                src={total_attendance_vehicle}
                                alt=""
                              />
                              <span className="total-attendance-text2">
                                Vehicles
                              </span>
                              <span className="total-attendance-number">
                                {todayAttVehCount.Totalvehicle ?? 0}
                              </span>
                            </div>

                            <div className="total-attendance-card">
                              <img
                                className="total-attendance-img"
                                src={total_attendance_courier}
                                alt=""
                              />
                              <span className="total-attendance-text2">
                                Couriers
                              </span>
                              <span className="total-attendance-number">
                                {todayAttCourCount.Totalcourier ?? 0}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default DashBoard;
